/**
 * 该文件精听和跟读都会引用，修改需考虑到兼容性问题
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { history } from 'routers';
import { connect } from 'react-redux';
import { View, Image, Button } from '@zhike/ti-ui';
import { Modal } from '@zhike/ti-component';
import { toeflUrl, ieltsUrl } from 'common/config';
import { smoothScroll } from 'utils/smoothScroll'
import { getLogoProp } from 'utils';
import styles from './styles';

const letter = ['A', 'B', 'C'];

// 页面头部
class Header extends Component {
  // 参数
  static defaultProps = {
    listenParts: [],
    exampleParts: [], // 跟读的范例
    canFollowUp: false, // 可跟读
    canIntensiveListening: false, // 可精听
    logo: {},
  };

  static propTypes = {
    listenParts: PropTypes.array,
    exampleParts: PropTypes.array,
    canFollowUp: PropTypes.bool,
    canIntensiveListening: PropTypes.bool,
    type: PropTypes.string.isRequired, // 区别精听和跟读：'listen'/'repeat'
    name: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired,
    examId: PropTypes.number.isRequired,
    getUploadSignature: PropTypes.func.isRequired,
    postCorrectionImage: PropTypes.func.isRequired,
    postCorrection: PropTypes.func.isRequired,
    logo: PropTypes.object,
  };

  componentDidMount() {
    const { type } = this.props;
    global.document.title = type === 'listen' ? '智课精听' : '智课跟读训练';
  }

  // 切换材料
  handlePart(index, e) {
    const { match, type } = this.props;
    const { practiceId } = match.params;
    const partId = +match.params.partId || 1;
    const search = global.location.search; // eslint-disable-line

    if (index !== partId) {
      history.push(`/${type}/${practiceId}/${index}${search}`);
    }

    if (e && e.currentTarget) {
      const element = e.currentTarget

      setTimeout(() => {
        smoothScroll({
          element,
          horizon: true,
          duration: 500,
        })
      }, 350)
    }
  }

  // 我要纠错
  handleCorrect() {
    const { getUploadSignature, postCorrectionImage, postCorrection, name, match } = this.props;
    const { practiceId } = match.params;
    Modal.show('ModalCorrect', {
      title: '我要纠错',
      isReport: true,
      width: 700,
      getUploadSignature,
      postCorrectionImage,
      postCorrection,
      step: { practice: { name, id: +practiceId } },
      option: {
        version: '1.0.0',
        source: 'ti-base',
      },
      type: 'followUpOrListen',
    });
  }

  // 去做题
  handlePractice() {
    const { match, examId } = this.props;
    const { practiceId } = match.params;
    const search = global.location.search; // eslint-disable-line

    if (examId === 1) {
      global.location.href = `${toeflUrl}/init/practice/${practiceId}${search}`;
    } else if (examId === 2) {
      global.location.href = `${ieltsUrl}/init/practice/${practiceId}${search}`;
    }
  }

  // 跟读页面：去精听
  toggleListenRepeat(target) {
    const { practiceId } = this.props.match.params;
    const search = global.location.search; // eslint-disable-line

    history.push(`/${target}/${practiceId}/${search}`);
  }

  // 跟读页面：音频命名规范
  getPartName(index) {
    const { listenParts, exampleParts } = this.props;

    if (index < listenParts.length) {
      return listenParts.length < 2 ? '材料音频' : `材料音频 ${index + 1}`;
    } else {
      return exampleParts.length < 2 ? '范例音频' : `范例音频 ${index - listenParts.length + 1}`;
    }
  }

  // 渲染
  render() {
    const {
      type, name, listenParts, exampleParts, match, canFollowUp, canIntensiveListening, logo,
    } = this.props;
    const partId = +match.params.partId || 1;
    const repeatParts = listenParts.concat(exampleParts);
    const source = decodeURIComponent(global.location.search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const logoProp = getLogoProp({ image: logo.data.image, styles });
    return (
      <View className={styles.container}>
        <View className={styles.title}>
          <Image {...logoProp} />
          <View className={styles.titleSplit} />
          <View className={styles.titleText} title={name}>
            {name}
          </View>
        </View>

        <View className={styles.parts}>
          {
            type === 'listen' &&
            listenParts.length > 1 &&
            listenParts.map((item, index) => (
              <View
                key={index}
                className={[styles.part, partId === (index + 1) && styles.selectedPart]}
                onClick={() => this.handlePart(index + 1)}
              >
                Part {letter[index]}
              </View>
            ))
          }
          {
            type === 'repeat' &&
            repeatParts.length > 1 &&
            repeatParts.map((item, index) => (
              <View
                key={index}
                className={[styles.part, partId === (index + 1) && styles.selectedPart]}
                onClick={e => this.handlePart(index + 1, e)}
              >
                {this.getPartName(index)}
              </View>
            ))
          }
        </View>

        <View className={styles.normalButtons}>
          {
            !source &&
            <Button
              className={styles.button}
              rightIcon={require('components/header/assets/test_next.png')}
              text="去做题"
              onClick={() => this.handlePractice()}
            />
          }
          {
            (type === 'listen' && canFollowUp) && source !== 'smart' &&
            <Button
              className={styles.button}
              rightIcon={require('components/header/assets/test_next.png')}
              text="去跟读"
              onClick={() => this.toggleListenRepeat('repeat')}
            />
          }
          {
            (type === 'repeat' && canIntensiveListening) && source !== 'smart' &&
            <Button
              className={styles.button}
              rightIcon={require('components/header/assets/test_next.png')}
              text="去精听"
              onClick={() => this.toggleListenRepeat('listen')}
            />
          }
          <Button
            className={styles.button}
            leftIcon={require('./assets/correct.png')}
            text="我要纠错"
            onClick={() => this.handleCorrect()}
          />
        </View>

        <Modal ref={modal => { Modal.instance = modal; }} />
      </View>
    );
  }
}

const mapStateToProps = state => ({
  logo: state.logo,
})

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/listen/header/index.js